import { render, staticRenderFns } from "./ReservationPointsBanner.vue?vue&type=template&id=59c99d7b&scoped=true&"
import script from "./ReservationPointsBanner.vue?vue&type=script&lang=js&"
export * from "./ReservationPointsBanner.vue?vue&type=script&lang=js&"
import style0 from "./ReservationPointsBanner.vue?vue&type=style&index=0&id=59c99d7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c99d7b",
  null
  
)

export default component.exports